import API_ENDPOINT_CONSTANTS from "../constants/endpointConstants";
import { apiGet, apiPost, apiPut } from "../utils/apiUtils";

const getMenusService = () => apiGet(API_ENDPOINT_CONSTANTS.MENUS);

const updateMenusService = (
  id: string,
  name: string,
  url: string,
  sequenceNumber: number
) =>
  apiPut(API_ENDPOINT_CONSTANTS.MENU, {
    id,
    name,
    url,
    sequenceNumber,
  });

const createMenusService = (
  name: string,
  url: string,
  sequenceNumber: number
) =>
  apiPost(API_ENDPOINT_CONSTANTS.MENU, {
    name,
    url,
    sequenceNumber,
  });

export { createMenusService, getMenusService, updateMenusService };
